import { IMacroModel } from '../MacroModel';

export interface IMacroRequest {
  macroId: number;
  name: string;
  macroTypeId: number;
  content: string;
  hospitalId: number;
  userId: number;
  isActive: boolean;
  rowVersion: string;
  macroTargetTypeId: number;
}

export class MacroRequest implements IMacroRequest {
  macroId: number;
  name: string;
  macroTypeId: number;
  content: string;
  hospitalId: number;
  userId: number;
  isActive: boolean;
  rowVersion: string;
  macroTargetTypeId: number;

  constructor(params: IMacroRequest) {
    this.macroId = params.macroId;
    this.name = params.name;
    this.macroTypeId = params.macroTypeId;
    this.content = params.content;
    this.hospitalId = params.hospitalId;
    this.userId = params.userId;
    this.isActive = params.isActive;
    this.rowVersion = params.rowVersion;
    this.macroTargetTypeId = params.macroTargetTypeId;
  }

  static ParseMacroRequest(macro: IMacroModel): MacroRequest {
    return {
      macroId: macro.macroId,
      name: macro.name,
      macroTypeId: macro.macroTypeId,
      content: macro.content,
      hospitalId: macro.hospitalId,
      userId: macro.userId,
      isActive: macro.isActive,
      rowVersion: macro.rowVersion,
      macroTargetTypeId: macro.macroTargetTypeId,
    };
  }
}
